export class PenOfferScopeDto {
  Id: number;
  MaterialsIncluded: boolean;
  MaterialsFixedPrice: boolean;
  MaterialsComment: string;
  LaborIncluded: boolean;
  LaborFixedPrice: boolean;
  LaborComment: string;
  SiteAndEquipmentIncluded: boolean;
  SiteAndEquipmentFixedPrice: boolean;
  SiteAndEquipmentComment: string;
  FreightIncluded: boolean;
  FreightFixedPrice: boolean;
  FreightComment: string;

  DeliveryWhere: string;
  DeliveryHow: string;
  DeliveryWhen: Date;
  DeliveryFreightTerms: string;
  DeliveryComments: string;

  SiteContact: string;
  SiteLocation: string;
  SiteSurface: string;
  SiteWorkingLights: string;
  SiteFacilityToilet: boolean;
  SiteFacilityElectricity: boolean;
  SiteFacilityCantine: boolean;
  SiteFacilityAccomodation: boolean;
  SiteFacilityElectricityVoltage: number;
  SiteFacilityElectricityAmpere: number;
  SiteFacilityElectricityPlugs: string;
  SiteCleanupCustomerBuyLeftover: boolean;
  SiteCleanupCustomerHandleWaste: boolean;
  SiteComments: string;

  CustomerEquipmentWeldingContainer: number;
  CustomerEquipmentTelescopicLoader: number;
  CustomerEquipmentWheelLoader: number;
  CustomerEquipmentForklift: number;
  CustomerEquipmentPowerGenerator: number;
  CustomerEquipmentCrewContainer: number;
  CustomerEquipmentStorage: number;
  CustomerEquipmentComment: string;

  LaborDetailsWorkersProvided: number;
  LaborMealsProvided: number;
  LaborAccomodationProvided: boolean;
  LaborSpecialRequirements: string;
  LaborComments: string;

  AccommodationArrangedByUs: boolean;
  AccommodationPaidByUs: boolean;
  AccommodationProvidedFor: number;
  AccommodationAddress: string;
  AccommodationContactDetails: string;
  AccommodationComments: string;

  LocalContactRentalEquipment: string;
  LocalContactAccomodation: string;
  LocalContactSite: string;
  LocalContactHelpers: string;
  LocalContactLogistics: string;
  LocalContactServiceBoat: string;
  LocalContactTugboat: string;
  LocalContactComments: string;
}
